import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { request } from '@vip-activity/business/service/request';
import { getRandomNoHitConfig } from '../util';
var actId = window.setting.魔方.活动ID;
var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity';

var addPrePublish = function addPrePublish() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (window.location.search.indexOf('is_prepublish') > -1) {
    return _objectSpread(_objectSpread({}, params), {}, {
      is_prepublish: 1
    });
  }

  return params;
};

var BatchService = /*#__PURE__*/function () {
  function BatchService() {
    _classCallCheck(this, BatchService);
  }

  _createClass(BatchService, null, [{
    key: "doLottery",
    value:
    /**
     *  顺序批量抽奖
     *  @param {String} act_id 活动id
     */
    function () {
      var _doLottery = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(modId, leftNum) {
        var options, lottery, _lottery, list, i, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _lottery = function _lottery3() {
                  _lottery = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt("return", new Promise(function (resolve) {
                              request()(baseUrl, addPrePublish(options)).then(function (data) {
                                var code = +data.lotter_result;

                                if (+data.ret === 0 && (code === 1 || code === -100)) {
                                  var _data$prize_list;

                                  resolve({
                                    result: code === 1,
                                    lottery: ((_data$prize_list = data.prize_list) === null || _data$prize_list === void 0 ? void 0 : _data$prize_list[0]) || getRandomNoHitConfig()
                                  });
                                  return;
                                }

                                resolve(null);
                              })["catch"](function (e) {
                                var ret = e.code;

                                if (+ret === -905) {
                                  resolve(e);
                                  return;
                                }

                                resolve(null);
                              });
                            }));

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                  return _lottery.apply(this, arguments);
                };

                lottery = function _lottery2() {
                  return _lottery.apply(this, arguments);
                };

                options = {
                  type: 100143,
                  option: 100,
                  act_id: actId,
                  module_id: modId
                }; // 单抽奖

                list = [];
                i = 0;

              case 5:
                if (!(i < leftNum)) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 8;
                return lottery();

              case 8:
                data = _context2.sent;
                list.push(data);

              case 10:
                i += 1;
                _context2.next = 5;
                break;

              case 13:
                return _context2.abrupt("return", list.filter(function (v) {
                  return !!v;
                }));

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function doLottery(_x, _x2) {
        return _doLottery.apply(this, arguments);
      }

      return doLottery;
    }()
  }]);

  return BatchService;
}();

export default BatchService;